// extracted by mini-css-extract-plugin
module.exports = {"livetickerList":"LiveTickerList__livetickerList___10ECt"};